import { Provider, Type } from '@angular/core';

import { Logger } from './logger.model';
import { LOGGERS } from './logger.token';

export function provideLogger(loggers: Type<Logger>[]): Provider[] {
  return loggers.map((logger) => ({
    provide: LOGGERS,
    multi: true,
    useClass: logger,
  }));
}
